import { ApiRequestInterceptor } from "./apiRequest";
import { REPARTIDORES } from "../Constants/Endpoints";

export const fetchGetOrdersForCourier = async () => {
  const method = "GET";
  const url = REPARTIDORES.getOrdersRepartidores; // 👈 usas tu constante

  const response = await ApiRequestInterceptor(url, method);

  // Normaliza: si body viene en string, lo parseamos
  const parsed = typeof response?.body === "string"
    ? JSON.parse(response.body)
    : response?.body;

  return {
    statusCode: response.statusCode || 200,
    ...response,
    body: parsed ?? response.body,
  };
};